<template>
  <!-- Form -->
  <div class="newsletter-form" :class="{ '--loading': loading }">
    <FormKit type="form" ref="formEl" :actions="false" @submit="onSubmit">
      <div class="form-row form-row-main">
        <!-- Email -->
        <FormKit
          type="email"
          name="email"
          :label="$t('footer.newsletter.emailField')"
          validation="required|email"
          :placeholder="$t('footer.newsletter.emailPlaceholder')"
        />
        <!-- Submit button -->
        <button
          type="submit"
          class="button-round-1 is-transparent-negative show-for-large"
        >
          <span>{{ $t('footer.newsletter.cta') }}</span>
        </button>
        <button type="submit" class="hide-for-large">
          <img
            class="w-100"
            src="@/assets/img/ico/freccia-arancio.svg"
            width="54"
            height="53"
            :alt="$t('footer.newsletter.cta')"
          />
        </button>
      </div>

      <div class="form-row form-row-gdpr">
        <!-- GDPR Check (desktop) -->
        <div>
          <FormKit
            type="checkbox"
            :label="$t('footer.newsletter.gdpr')"
            name="gdpr"
            validation="accepted"
            :validation-messages="{
              accepted: $t('footer.newsletter.gdprError'),
            }"
          >
            <template #label>
              <div class="gdpr-checkbox-text">
                <!-- TODO: Capire  come mai non parsa le quotes che vengono dal $t -->
                <!--
                <p>
                  Pursuant to and in accordance with EU Reg. 2016/679 - GDPR I
                  give my consent to the processing of my personal data as per
                  the
                  <a target="“_blank”" href="/privacy-policy">privacy notice</a>
                </p>
                -->
                <p
                  v-html="
                    $t('form.termsExtLabel', {
                      url: localePath({
                        name: 'privacy-policy',
                      }),
                    })
                  "
                />
              </div>
            </template>
          </FormKit>
        </div>
      </div>

      <!-- Consenso tracciamento statistico: scelta esplicita, nessuna opzione preselezionata -->
      <div class="form-row form-row-gdpr">
        <div>
          <FormKit
            type="radio"
            name="tracking"
            :options="[
              { label: $t('footer.newsletter.tracking'), value: 'yes' },
              { label: $t('footer.newsletter.trackingDenied'), value: 'no' },
            ]"
            validation="required"
            :validation-messages="{
              required: $t('footer.newsletter.gdprError'),
            }"
          >
            <template #label="{ option }">
              <div class="gdpr-checkbox-text">
                <p>{{ option.label }}</p>
              </div>
            </template>
          </FormKit>
        </div>
      </div>
    </FormKit>
  </div>
</template>

<script>
export default {
  name: 'NewsletterForm',
}
</script>

<script setup>
import { reset } from '@formkit/core'

const emit = defineEmits(['newsletter:success', 'newsletter:failure'])

const formEl = ref(null)
const loading = ref(false)

const MAILUP_API =
  'https://services.mailup.com/API/v1.1/Rest/ConsoleService.svc/Console'
const MAILUP_LIST_ID = '5'
const MAILUP_GROUP_ID = '517'

const onSubmit = async (formkitData, node) => {
  node.clearErrors()
  loading.value = true

  try {
    // Step1: access token (via Nodered, che proxa le credenziali Mailup)
    const tokenRes = await fetch('https://nodered.quammbase.it/suntimes/mailup')
    const { access_token: accessToken } = await tokenRes.json()
    if (!accessToken) throw new Error('Mailup: access token mancante')

    const headers = {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${accessToken}`,
    }

    // Step2: iscrizione al Group (iscrive automaticamente anche alla List padre), con double opt-in
    // https://helpmailup.atlassian.net/wiki/spaces/mailupapi/pages/36342519/Recipients
    const subscribeRes = await fetch(
      `${MAILUP_API}/Group/${MAILUP_GROUP_ID}/Recipient?ConfirmEmail=true`,
      {
        method: 'POST',
        headers,
        body: JSON.stringify({ Email: formkitData.email }),
      }
    )
    if (!subscribeRes.ok) {
      throw new Error(`Mailup subscribe: HTTP ${subscribeRes.status}`)
    }
    const idRecipient = await subscribeRes.json()

    // Step3: consenso al tracciamento statistico individuale (Provv. Garante n. 284/2026).
    // Inviato sempre in modo esplicito, così vale anche per chi si re-iscrive dopo una revoca.
    // Senza consenso Mailup anonimizza aperture/clic del destinatario (restano solo nelle statistiche aggregate).
    try {
      const trackingRes = await fetch(
        `${MAILUP_API}/List/${MAILUP_LIST_ID}/Tracking/${idRecipient}`,
        {
          method: 'POST',
          headers,
          body: JSON.stringify({ Enable: formkitData.tracking === 'yes' }),
        }
      )
      if (!trackingRes.ok) {
        throw new Error(`Mailup tracking: HTTP ${trackingRes.status}`)
      }
    } catch (error) {
      // L'iscrizione è già avvenuta: non la segnaliamo come fallita all'utente
      console.error(error)
    }

    emit('newsletter:success')
    reset(node)
  } catch (error) {
    console.error(error)
    emit('newsletter:failure')
  } finally {
    loading.value = false
  }
}
</script>

<style lang="scss">
@import './style.scss';
</style>
